import { EmployeeCardLoader } from '@/components/loader'
import Block from '@/layouts/block'

export const LoaderBlockEmployees = () => (
  <Block className="col-start-1 col-end-3 md:col-start-3 md:col-end-7 lg:col-start-5 lg:col-end-13 w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-lg">
    <EmployeeCardLoader className="bg-neutral-white rounded-sm" />
    <EmployeeCardLoader className="bg-neutral-white rounded-sm" />
    <EmployeeCardLoader className="bg-neutral-white rounded-sm" />
  </Block>
)
